export default [{
        path: '/vocal_novels',
        component: resolve => require(['../../../view/find/Vocal_Novels/Vocal_Novels.vue'], resolve),
    },
    {
        path: '/vocal_detail',
        component: resolve => require(['../../../view/find/Vocal_Novels/vocal_detail/vocal_detail.vue'], resolve),

    },
    {
        path: '/anchor_details',
        component: resolve => require(['../../../view/find/Vocal_Novels/vocal_detail/anchor_details.vue'], resolve),

    },
    {
        path: '/vocal_more',
        component: resolve => require(['../../../view/find/Vocal_Novels/subclass/more.vue'], resolve),

    },
    {
        path: '/Albumdetails',
        component: resolve => require(['../../../view/find/Vocal_Novels/vocal_detail/subclass/Albumdetails.vue'], resolve),

    }, {
        path: '/vocal_class',
        component: resolve => require(['../../../view/find/Vocal_Novels/vocal_detail/vocal_class.vue'], resolve),

    }, {
        path: '/vocal_search',
        component: resolve => require(['../../../view/find/Vocal_Novels/vocal_detail/subclass/vocal_search.vue'], resolve),

    }
]


// WEBPACK FOOTER //
// ./src/router/find/vocal_novels/index.js